import { TemplateLink } from "./TemplateLink"

export default function DakiContent() {
  return (
    <>
      <h2>Origin &amp; history</h2>
      <p>
        DAKI (Drop, Add, Keep, Improve) emerged from the agile practitioner
        community in the late 2000s. No single author to point at; it's the
        format teams tend to invent independently once they've gotten bored
        of{" "}
        <TemplateLink to="start-stop-continue">Start / Stop / Continue</TemplateLink>{" "}
        and realized "improve" is a useful third gear between "keep it" and
        "throw it out."
      </p>

      <h2>When to use this format</h2>
      <p>
        Use it when your team has processes that mostly work but need tuning.
        Start / Stop / Continue forces a binary; either something goes on the
        Continue list or on the Stop list. DAKI's "Improve" column is where
        the interesting work usually lives: the standup that's fine but too
        long, the review process that helps but slows merges, the tooling
        that works but only for people who set it up themselves.
      </p>

      <h2>When NOT to use this format</h2>
      <p>
        Skip it for brand-new teams. DAKI assumes there's a Keep pile worth
        defending and an Improve pile with enough shared context for people
        to have opinions about. Neither is true in a team's first quarter;
        they're still figuring out what they even do.
      </p>

      <h2>How to run it</h2>
      <p>
        Ten minutes silent writing per column, then group and vote. Spend
        the discussion time on Improve, not Drop. Dropping things is easy;
        improving them is where facilitation earns its keep. Assign owners
        for the top two Improve items before you close, and be honest that
        Add items usually need someone to sponsor them or they die.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        The Improve column fills with vague wishes ("improve our
        documentation"). Push for specificity: <em>what</em> documentation,
        <em> how</em> improved, and <em>who</em> notices it changed. A vague
        Improve is just a Keep that lost its confidence.
      </p>
    </>
  )
}
